/** @format */

import { addDays, endOfWeek, format, startOfWeek } from "date-fns";
import moment from "moment";

export const formateChange24Hour = (value) => {
  return moment(value, "hh:mm A").format("HH:mm:ss");
};
export const formateChange12Hour = (value) => {
  return moment(value, "HH:mm:ss").format("h:mm A");
};
export const TodayDate = () => {
  return moment().format("YYYY-MM-DD");
};

export const formatChangePoint = (value) => {
  if (typeof value !== "string") {
    return "";
  }
  return value.replace(/[:\\-]/g, "."); // Removed the escape for the forward slash
};
export const YearGet = (value) => {
  return moment(value).format("YYYY");
};
export const AthenaDateformat = (value) => {
  return moment(value).format("MM/DD/YYYY");
};
export const formatChangeLetters = (value) => {
  return moment(value, "YYYY/MM/DD").format("ddd MMM D");
};
export const formatChangeLetterLayline = (value) => {
  return moment(value, "MM/DD/YYYY").format("ddd MMM D");
};
export const formatChangeDayDateLayline = (value) => {
  return moment(value, "MM/DD/YYYY").format("ddd D");
};
export const formatChangeDate = (value) => {
  return moment(value, "YYYY/MM/DD").format("YYYY/MM/DD");
};
export const formatChangeDateSlash = (value) => {
  return moment(value).format("YYYY-MM-DD");
};
export const formatChangeDays = (value) => {
  return moment(value).fromNow();
};

export const formateChangeUnderScore = (value) => {
  return moment(value).format("YYYY-MM-DD");
};
export const dateFormate = (value) => {
  return moment(value).format("MMM DD YYYY");
};
export const payloadDateFormat = (value) => {
  return moment(value).format("MM/DD/YYYY");
};

export const removeWhiteSpace = (str) => {
  if (!str) return "";
  const value = str?.toLowerCase()?.replace(/\s+/g, "");
  return value;
};

// export function Datechange(datetimeStr) {
//   // Parse the original date using moment
//   const originalDate = moment(datetimeStr, "MM/DD/YYYY HH:mm");

//   // Adjust to the desired date (Sep 10, 2024, at 10:00 PM)
//   const adjustedDate = moment("2024-09-10 22:00", "YYYY-MM-DD HH:mm");

//   // Format the adjusted datetime
//   const formattedDate = adjustedDate.format("MMM DD, @ hh:mm A YYYY");

//   return formattedDate;
// }
export const formatChangeNumber = (value) => {
  if (typeof value !== "string") {
    return "";
  }
  return value.replace(/[a-zA-Z!@#$%^&*()_+=[\]{};':"\\|,.<>/?`~ -]/g, "");
};

export const handlePaginationFilter = (cardcount = 6, page, sorted) => {
  const count = cardcount;
  const startIndex = count * page - count;
  const endIndex = startIndex + count - 1;

  const fitlerPagination = sorted.filter(
    (v, i) => startIndex <= i && endIndex >= i
  );
  return fitlerPagination;
};

export const UniqueNumber = () => {
  return Date.now();
};

export const previousTimeCheck = (time, date) => {
  const currentMonth = new Date().getMonth() + 1;
  const currentDay = new Date().getDate();
  const currentHours = new Date().getHours();
  const currentMin = new Date().getMinutes();
  const currentYear = new Date().getFullYear();
  const [years, month, day] = formatChangeDate(date).split("/");

  const time24hr = formateChange24Hour(time);
  const previousTimeDiabled =
    Number(month) === Number(currentMonth) &&
    Number(day) === Number(currentDay) &&
    Number(currentYear) === Number(years) &&
    parseFloat(formatChangePoint(time24hr)) <=
      parseFloat(formatChangePoint(`${currentHours}:${currentMin}`));
  return previousTimeDiabled;
};
export const generateWeekDates = (currentDate) => {
  // Calculate the start and end of the current week (Monday - Sunday)
  const startDate = startOfWeek(currentDate, { weekStartsOn: 1 });
  const endDate = endOfWeek(currentDate, { weekStartsOn: 1 });

  const weekDates = [];

  // Generate dates from Monday to Sunday
  for (let date = startDate; date <= endDate; date = addDays(date, 1)) {
    const formattedDate = moment(date).format("MM/DD/YYYY");
    const dayOfWeek = format(date, "EEE");

    const isAvailable = !(dayOfWeek === "Sat" || dayOfWeek === "Sun");

    // Only include dates from Monday to Friday
    if (isAvailable) {
      weekDates.push({
        day: dayOfWeek,
        date: formattedDate,
        isAvailable,
      });
    }
  }

  return weekDates;
};
export function formatDateRange(date1, date2) {
  const startDate = moment(date1);
  const endDate = moment(date2);

  // Check if both dates are in the same month
  if (startDate.isSame(endDate, "month")) {
    return startDate.format("MMM-YYYY"); // Return "Sep-2024" format if dates are in the same month
  } else if (startDate.isSame(endDate, "year")) {
    // Return "Sep-Oct-2024" format if dates are in different months
    return `${startDate.format("MMM")}-${endDate.format(
      "MMM"
    )}-${startDate.format("YYYY")}`;
  } else {
    // Return "Dec-2024-Jan-2025" for different months and years
    return `${startDate.format("MMM-YYYY")}-${endDate.format("MMM-YYYY")}`;
  }
}
export const formatDate = (date) => {
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};

export const formateWeeks = (date, formate = "ddd") => {
  return moment(date).format(formate);
};
export const formateDay = (date) => {
  return moment(date).format("DD");
};
export const formateMonth = (date) => {
  return moment(date).format("MMM");
};

export const CheckTimeAMorPM = (value) => {
  const time = moment(value, "HH:mm");
  return time.format("A") === "AM";
};
